import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import styled from 'styled-components';
import { validate } from '~common/validator';
import { emailValidation, isNotEqualValidation } from '~common/validator/validations';
import { t } from '~web/i18n';
import { TextInputFieldProps } from '~common/components/form/props';
import { TextInput } from '~common/components/form/text-input.component';

export interface EmailFormData {
  email: string;
}

interface EmailValidation {
  email: string;
}

interface Props extends TextInputFieldProps<string> {
  type?: string;
  hasLockIcon?: boolean;
}

export const EmailField: React.FunctionComponent<Props> = ({
  label,
  type,
  hasLockIcon,
  ...rest
}) => {
  return (
    <Field
      label={label ?? t('form.label.email')}
      name="email"
      render={(renderProps): ReactNode => (
        <StyledTextInput
          fullWidth
          type={type ?? 'email'}
          hasLockIcon={hasLockIcon}
          {...renderProps}
        />
      )}
      {...rest}
    />
  );
};

const StyledTextInput = styled(TextInput)`
  .text-input-container > .MuiInputBase-root {
    border-bottom-style: solid !important;
  }
`;

//TODO: Fix validation error translations for modules other than web
export const EmailValidator: (values: any & EmailFormData) => EmailValidation = (
  values: any & EmailFormData,
): EmailValidation => ({
  email: validate(values.email, [emailValidation]),
});

export const EmailNotEqualValidator: (
  values: any & EmailFormData,
  otherEmail: string,
) => EmailValidation = (values: any & EmailFormData, otherEmail: string): EmailValidation => ({
  email: validate(values.email, [emailValidation, isNotEqualValidation(otherEmail)]),
});



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/components/form/email-field.component.tsx